export default "__VITE_ASSET__476f9a67__"